<template>
    <div class="w-full bg-white flex flex-col items-start justify-start">
        <div
            class="
                mt-10
                font-semibold
                text-3xl
                w-full
                whitespace-pre-wrap
                text-black
            "
        >
            {{ `Herzlichen Glückwunsch ${GET_USER.full_name}!` }}
        </div>
        <div
            class="mt-4 mb-12 text-grey text-left text-lg w-full"
            v-if="GET_COURSE != null"
        >
            Sie haben erfolgreich den Kurs "{{ GET_COURSE.name }}"
            abgeschlossen.<br />
            <span v-if="GET_CERTIFICATE"
                >Ihr Zertifikat steht ab sofort hier und bei Ihren Dokumenten
                zum Download bereit! Sollte Ihr Kurs ein zweites Zertifikat beinhalten, wird Ihnen dieses auch im Bereich "Meine Dokumente" abgelegt.
            </span>
        </div>
        <div
            v-if="GET_CERTIFICATE"
            class="
                w-full
                max-h-screen max-w-xl
                flex flex-col
                items-start
                justify-start
            "
            style="height: 700px"
        >
            <embed width="100%" height="100%" :src="certificateSrc" />
            <custom-button
                class="w-60 h-11 mt-8 mb-12"
                :text="'Zertifikat herunterladen'"
                :bgColor="'bg-primary'"
                :textColor="'text-white'"
                :id="'download-button'"
                @click="DOWNLOAD_CERTIFICATE"
            >
                <template #icon>
                    <download-icon
                        :fillClass="'fill-white'"
                        class="mr-2"/></template
            ></custom-button>
        </div>
        <div v-else class="text-grey text-lg w-full">
            Dein Zertifikat steht noch nicht zur verfügung. <br />
            Ihre Daten werden geprüft und ein Zertifikat wird erstellt. Bitte
            überprüfen Sie ihr Zertifikat zu einem anderen Zeitpunkt.
        </div>
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
} from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
    HELPER_TYPES,
    STORE_TYPES,
    CERTIFICATE_TYPES,
    AUTH_USER_TYPES,
    COURSE_TYPES,
} from "../../../store/types";
import CustomButton from "../../../components/input/CustomButton.vue";

export default defineComponent({
    name: "Certificate",
    components: { CustomButton },
    setup() {
        const store = useStore();
        const route = useRoute();
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */
        async function FETCH_CERTIFICATE() {
            return store.dispatch(
                `${STORE_TYPES.CERTIFICATES}/${CERTIFICATE_TYPES.FETCH_CERTIFICATE}`,
                { courseId: route.params.id }
            );
        }
        function DOWNLOAD_CERTIFICATE() {
            store.dispatch(
                `${STORE_TYPES.CERTIFICATES}/${CERTIFICATE_TYPES.DOWNLOAD_CERTIFICATE}`,
                { courseId: route.params.id }
            );
        }

        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_CERTIFICATE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.CERTIFICATES}/${CERTIFICATE_TYPES.GET_CERTIFICATE}`
                ]
        );
        const GET_USER = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`
                ]
        );

        const certificateSrc = computed(
            () =>
                `${process.env.VUE_APP_API_URL}/academy/courses/${route.params.id}/certificate#toolbar=0&navpanes=0&scrollbar=0`
        );

        /**x
         *  Created
         */

        onMounted(() => {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "isLoadingData"
            );
            FETCH_CERTIFICATE().then(() => {
                store.commit(
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                    "isLoadingData"
                );
            });
        });
        return {
            state,
            GET_CERTIFICATE,
            GET_USER,
            certificateSrc,
            DOWNLOAD_CERTIFICATE,
            GET_COURSE,
        };
    },
});
</script>